import { motion } from "framer-motion";
import { SCREENSHOTS } from "@/config/site";
import SectionHeading from "@/components/SectionHeading";

const Spotlight = () => (
  <section data-testid="product-spotlight" className="bg-white py-20 sm:py-28">
    <div className="mx-auto max-w-7xl px-4 sm:px-8">
      <SectionHeading
        eyebrow="The Dugout, In Your Pocket"
        title="Built for game day. Ready for practice."
        sub="Real screens from the CoachER app — practice plans, field lineups, and batting orders, organized the way coaches actually work."
      />
      <div className="mt-14 grid grid-cols-1 gap-8 sm:grid-cols-2 lg:grid-cols-4 lg:gap-6">
        {SCREENSHOTS.map((s, i) => (
          <motion.figure
            key={s.num}
            data-testid={`spotlight-frame-${s.num}`}
            initial={{ opacity: 0, y: 40, rotate: i % 2 === 0 ? -1.5 : 1.5 }}
            whileInView={{ opacity: 1, y: 0, rotate: i % 2 === 0 ? -1.5 : 1.5 }}
            whileHover={{ rotate: 0, y: -8 }}
            viewport={{ once: true, margin: "-60px" }}
            transition={{ duration: 0.7, delay: i * 0.1, ease: [0.22, 1, 0.36, 1] }}
            className="group"
          >
            <div className="relative overflow-hidden rounded-2xl border border-coacher-border bg-coacher-navy shadow-frame">
              <img src={s.src} alt={s.title} loading="lazy" className="w-full object-cover transition-transform duration-500 group-hover:scale-[1.03]" />
              <span className="absolute left-4 top-4 font-varsity text-2xl text-white drop-shadow-[0_2px_6px_rgba(5,30,64,0.8)]">{s.num}</span>
            </div>
            <figcaption className="mt-5">
              <p className="font-display text-lg font-semibold uppercase tracking-wide text-coacher-navy">{s.title}</p>
              <p className="mt-1.5 text-sm leading-relaxed text-coacher-slate">{s.blurb}</p>
            </figcaption>
          </motion.figure>
        ))}
      </div>
    </div>
  </section>
);

export default Spotlight;
